import React from 'react';
import "./App.css";

class App extends React.Component {
  render = () => {
    return (
      <div className="card">
        <div className="header">
          <div className="logo">
            <a href=".">Kai Harrington</a>
          </div>
        </div>
        <div className="content">
          <div className="title-holder">
            <h1>Get ready for a change.</h1>
            <p>Website coming soon. Shoot me an email if you're curious.</p>
          </div>
          <a href="mailto:contact@kaiharrington.net">
            <div className="cta">Send me an email</div>
          </a>
        </div>
        <div className="footer">
          <span>Copyright &copy; 2022 | Kai Harrington</span>
        </div>
      </div>
    );
  }
}

export default App;